import React, { useContext, useEffect, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';

import { useNavigate } from 'react-router-dom';

import BackEndAPI from '../../../Services/BackEndAPI';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';

import { Box, Button, Container, Grid, IconButton, Paper, Tab, Tabs, Typography } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import TextArea from '../../../DevComponents/TextArea';
import { TipoERPInterface, TipoERPType } from '../../../ImportBackend/types/ConstantesDataTypes';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';
import Condicional from '../../../Layout/Condicional';
import { DrgXMLInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces';
import { clsUtils } from 'zlib-utils';

export default function DRGCadastroXML() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const navigate = useNavigate()

  const ResetDados: DrgXMLInterface = {
    idDrgXML: 0,
    xmlAdmissao: '',
    xmlAlta: ''
  }

  const [dados, setDados] = useState<DrgXMLInterface>({ ...ResetDados })
  const [conteudoOriginal, setConteudoOriginal] = useState<DrgXMLInterface>({ ...ResetDados })

  const clsApi: BackEndAPI = new BackEndAPI()

  const onChangeTipoERP = () => {

    const query = `
        getDrgXml {
          idDrgXML
          xmlAdmissao
          xmlAlta
        }
      `

    clsApi.query<DrgXMLInterface>(query, 'getDrgXml', 'Consultando XML...', contexto).then(rsXML => {

      setDados(rsXML)
      setConteudoOriginal(rsXML)

    }).catch(() => {

      setDados(ResetDados)

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao consultar XML do DRG!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })

  }

  const onGravarXML = () => {

    const mutation = `
        updateDrgXml (dados: ${clsUtils.ConverterEmGql(dados)}) {
          ok
          mensagem
        }
      `

    clsApi.mutation<RespostaPadraoInterface>(mutation, 'updateDrgXml', 'Atualizando XML...', contexto).then(rsXML => {

      if (!rsXML.ok) {
        setMensagemState({
          ...mensagemState,
          titulo: 'Erro ao atualizar XML do DRG!',
          exibir: true,
          mensagem: rsXML.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      } else {
        setConteudoOriginal(dados)
      }


    }).catch(() => {

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao atualizar XML do DRG!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })

  }

  const [rsTab, setRsTab] = useState(0)

  const changeRsTab = (_event: React.SyntheticEvent, newValue: number) => {
    setRsTab(newValue)
  }

  useEffect(() => {

    onChangeTipoERP()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (

    <>

      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>

              <Typography component="h5" variant="h5" align="left">
                Cadastro XML DRG
                <Typography variant="body2" gutterBottom>
                  Cadastro do XML para geração do DRG por tipo de ERP
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Grid item xs={12}>

              <Box sx={{ width: '100%' }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={rsTab} onChange={changeRsTab} aria-label="drg envio tabs">
                    <Tab label="Admissão" />
                    <Tab label="Alta" />
                  </Tabs>
                </Box>

                <Condicional condicao={rsTab === 0}>

                  <TextArea
                    dados={dados}
                    field='xmlAdmissao'
                    label='XML Admissão'
                    setState={setDados}
                    height='300px'
                  />
                </Condicional>

                <Condicional condicao={rsTab === 1}>
                  <TextArea
                    dados={dados}
                    field='xmlAlta'
                    label='XML Alta'
                    setState={setDados}
                    height='300px'
                  />
                </Condicional>
              </Box>

            </Grid>

            <Grid item xs={12} sx={{ mt: 1, textAlign: 'right' }} >
              <Button disabled={JSON.stringify(dados) !== JSON.stringify(conteudoOriginal) ? false : true} variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onGravarXML()}>Gravar</Button>
            </Grid>

          </Grid>
        </Paper>
      </Container>

    </>

  )
}